var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      attrs: {
        title: _vm.$t("pc_biz_place_title" /* 选择场地 */),
        direction: "rtl",
        "before-close": _vm.handleClose,
        visible: _vm.visible,
        size: "960px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "yxt-container",
        { staticClass: "yxtbiz-place-selector" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "tree",
              staticClass: "yxtbiz-place-selector__aside",
            },
            [
              _c("yxt-tree", {
                attrs: {
                  data: _vm.categorieList,
                  "wrap-width": "200",
                  "node-key": "id",
                  "expand-on-click-node": false,
                  "default-expanded-keys": ["0"],
                },
                on: { "node-click": _vm.handleTreeClick },
              }),
            ],
            1
          ),
          _c("placeTable", {
            ref: "refPlaceTable",
            attrs: {
              districtId: _vm.districtId,
              address: _vm.address,
              cityId: _vm.cityId,
              provinceId: _vm.provinceId,
            },
            on: { complete: _vm.complete },
          }),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "yxt-button",
            { attrs: { plain: "" }, on: { click: _vm.handleClose } },
            [_vm._v(_vm._s(_vm.$t("pc_biz_core_btn_cancel" /* 取消 */)))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }